module.exports = __webpack_public_path__ + "static/media/opening_08.29b179b3.webp";